import i18n from "@/i18n";
export function numberToRupiah(number) {
  return Intl.NumberFormat(i18n.global.locale.value ?? "id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(number);
}
